import type { SvgPathProps } from '../Icon';

import { getIcon } from '../Icon/utils';

const DotQuestionMark: React.FC<SvgPathProps> = ({ size, isHovered }: SvgPathProps): React.ReactElement => {
  const xxSmall = (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 40c8.837 0 16-7.163 16-16S32.837 8 24 8 8 15.163 8 24s7.163 16 16 16Zm-3.25-19.778c0-1.104 1.16-2.472 3.25-2.472s3.25 1.368 3.25 2.472c0 .944-.533 1.532-1.793 2.467l-.257.189c-.517.378-1.17.856-1.681 1.388-.655.683-1.269 1.639-1.269 2.934v.8h3.5v-.8c0-.083.011-.216.294-.51.281-.293.643-.56 1.167-.945l.332-.245c1.24-.92 3.207-2.444 3.207-5.278 0-3.569-3.306-5.972-6.75-5.972s-6.75 2.404-6.75 5.972h3.5ZM26 33a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
    />
  );

  const xxSmallHover = (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.59 39.377c8.494 2.435 17.354-2.476 19.79-10.97 2.436-8.495-2.476-17.355-10.97-19.79-8.494-2.437-17.355 2.475-19.79 10.97-2.436 8.493 2.476 17.354 10.97 19.79Zm2.327-19.908c.304-1.061 1.797-2.056 3.806-1.48 2.008.575 2.747 2.21 2.442 3.271-.26.908-.934 1.326-2.403 1.878l-.299.11c-.6.221-1.361.501-1.999.872-.818.475-1.671 1.225-2.028 2.47l-.22.769 3.364.965.22-.77c.023-.079.07-.203.423-.408.351-.205.773-.361 1.383-.588l.386-.144c1.446-.543 3.757-1.465 4.538-4.189.983-3.43-1.532-6.652-4.843-7.601-3.31-.95-7.15.45-8.134 3.88l3.364.965Zm1.525 13.73a2 2 0 1 1-3.845-1.103 2 2 0 0 1 3.845 1.103Z"
    />
  );

  return getIcon({
    size,
    isHovered,
    normal: xxSmall,
    normalHover: xxSmallHover,
  });
};

export default DotQuestionMark;
